<template>
  <flow-part :id="$options.name">
    <template #heading>
      <h2>Leveringsadres</h2>
    </template>

    <template #content>
      <section v-auto-animate>
        <div class="address-display">
          <span v-show="compareLocationDisplay" class="address-part">
            {{ compareLocationDisplay }}
          </span>
        </div>

        <checkbox-input id="residential_location" v-model="orderStore.residential_location">
          Dit is een woon- en/of werkadres
        </checkbox-input>

        <div v-if="!orderStore.residential_location" class="tip small">
          <strong>Let op:</strong>
          Je hebt aangegeven dat dit geen woon- en/of werkadres is, bijvoorbeeld omdat het gaat om een garagebox of een
          schuur.
          In dat geval heb je geen recht op vermindering van je energiebelasting. Hierdoor betaal je
          {{ toCurrencyEur(productPricingCalculation.tax_discount) }} meer dan het genoemde jaarbedrag.
          <br>
          <br>
          Kun je wel wonen of werken op dit adres? Bijvoorbeeld een woonhuis, appartement, kantoor of vakantiehuisje?
          Pas
          dan je keuze aan.
        </div>

        <checkbox-input id="billing_address_equals_delivery_address"
          v-model="orderStore.billing_address_equals_delivery_address" class="field-margin">
          Dit is ook mijn postadres
        </checkbox-input>

        <div v-if="!!!orderStore.billing_address_equals_delivery_address" class="highlight-group tip">
          <h5>Postadres</h5>
          <section class="text-group street">
            <text-input id="billing_address_street" v-model="orderStore.billing_address_street"
              v-model:error="orderStore.errors.billing_address_street" label="Straat" />
            <text-input id="billing_address_number" v-model="orderStore.billing_address_number"
              v-model:error="orderStore.errors.billing_address_number" label="Huisnr." />
            <text-input id="billing_address_number_addition" v-model="orderStore.billing_address_number_addition"
              v-model:error="orderStore.errors.billing_address_number_addition" label="Toev." />
          </section>
          <section class="text-group postal-code">
            <text-input id="billing_address_postal_code" v-model="orderStore.billing_address_postal_code"
              v-model:error="orderStore.errors.billing_address_postal_code" label="Postcode" />
            <text-input id="billing_address_city" v-model="orderStore.billing_address_city"
              v-model:error="orderStore.errors.billing_address_city" label="Plaats" />
          </section>
        </div>
      </section>

      <!-- Radio -- Is moving -->
      <FieldLabelWithTooltip label="Is deze aanvraag voor een verhuizing?">
        <template #tooltip>
          <Tooltip position="top-right">
            <template #text>
              Wanneer je gaat verhuizen vragen we je wanneer je energiecontract in moet gaan.
            </template>
          </Tooltip>
        </template>
      </FieldLabelWithTooltip>


      <section class="radio-group">
        <big-radio-input id="moving-y" v-model="orderStore.moving_in" title="Ja" :value="true" />

        <big-radio-input id="moving-n" v-model="orderStore.moving_in" title="Nee" :value="false" />
      </section>
    </template>
  </flow-part>
</template>

<script>
import BigRadioInput from 'vue-elements/input/BigRadioInput.vue';
import CheckboxInput from 'vue-elements/input/CheckboxInput.vue';
import TextInput from 'vue-elements/input/TextInput.vue';
import FormPartMixin from '../../lib/FormPartMixin';
import { energyAllProviders, sortProviders } from '../../../../../assets/js/variables/providers.js';
import FlowPart from '../FlowPart.vue';
import { useOrderStore } from '../../stores/orderStore.js';
import { useEnergyComparisonStore } from '../../stores/energyComparison.js';
import FieldLabelWithTooltip from '../../../../vue-elements/field/FieldLabelWithTooltip.vue'
import Tooltip from '../../../../../abstracts/elements/tooltip/tooltip.vue';

export default {
  name: 'DeliveryAddressPart',
  mixins: [FormPartMixin()],
  components: {
    TextInput,
    CheckboxInput,
    BigRadioInput,
    FlowPart,
    FieldLabelWithTooltip,
    Tooltip,
  },
  setup() {
    const orderStore = useOrderStore();
    const comparisonStore = useEnergyComparisonStore();

    return {
      orderStore,
      comparisonStore,
    };
  },
  data() {
    return {
      providers: [],
    };
  },
  computed: {
    compareLocationDisplay() {
      return this.comparisonStore.compareLocation?.display || 'Locatie';
    },
    productPricingCalculation() {
      return this.orderStore.product.price_calculation;
    },
  },
  // Move provider options list to global helper
  created() {
    this.providers = sortProviders(energyAllProviders(), ['nuon', 'essent', 'eneco']);

    this.providers.push(
      {
        label: 'Geen i.v.m. verhuizing',
        value: 'moving',
      },
      {
        label: 'Onbekend/Geen',
        value: 'no-provider',
      },
    );
  },
};
</script>

<style lang="scss" scoped>
@use '../../../../../assets/scss/_variables/colors';
@use '../../../../../assets/scss/_helpers/display';
@use '../../../../../assets/scss/_helpers/breakpoint';
@use '../../style/helpers';


.checkbox-element {
  margin-top: 8px;

  &:first-of-type {
    margin-top: 16px;
  }
}

.is-moving-label {
  margin-top: 32px;
}

.text-group {
  margin: 16px 0;
  display: grid;
  gap: 16px;

  &.postal-code {
    grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  }
}

.radio-group {
  display: grid;
  grid-gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  margin-top: -6px;

  @include breakpoint.up(sm) {
    max-width: 312px;
  }
}

.address-display {
  @include display.flex-row-start;
  width: 100%;
  background-color: colors.$grey-10;
  // color: colors.$text-subtle;
  font-weight: 500;
  border: 1px solid colors.$border-base;
  padding: 16px;
  border-radius: 15px;
  margin-bottom: 32px;
}

.input-select-element {
  @include helpers.field-group-spacing-top;
}

.field-margin {
  margin: 32px 0;
}

.checkbox-input-field {
  margin: 16px 0;
}
</style>
